<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Customer Tables Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.customerTablesEntegration">Customer Table</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.customerTableLinkedFeature">Tablo İlişkilendirme</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.customerTableAIFeature">AI Destekli Kayıt</a-checkbox>
                </div>

                <div class="feature-label">Tablo Oluşturma Limiti</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.customerTableCount" />
                </div>
                <div class="feature-label">Tablo Başına Alan</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.customerTableFieldCount" />
                </div>
                <div class="feature-label">Tablo Başına Kayıt</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.customerTableRecordCount" />
                </div>
                <div class="feature-label">Tablo Başına Görüntü Oluşturma</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.customerTableViewCount" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    name: "CustomerTablesFeature",
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            customerTablesEntegration: true,
            customerTableLinkedFeature: false,
            customerTableAIFeature: false,
            customerTableCount: 0,
            customerTableFieldCount: 0,
            customerTableRecordCount: 0,
            customerTableViewCount: 0,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.CUSTOMER_TABLES);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.CUSTOMER_TABLES, ...this.featureForm };
                response[Features.CUSTOMER_TABLES.COUNT] = +v.customerTableCount || 0;
                response[Features.CUSTOMER_TABLES.FIELD_COUNT] = +v.customerTableFieldCount || 0;
                response[Features.CUSTOMER_TABLES.RECORD_COUNT] = +v.customerTableRecordCount || 0;
                response[Features.CUSTOMER_TABLES.VIEW_COUNT] = +v.customerTableViewCount || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.CUSTOMER_TABLES);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
